import * as remoteAction from "../remoteAction";

export type GetMemberTierCustomerActionSuccess =
  remoteAction.MerchantRemoteResponse<"GET_MEMBER_TIER_CUSTOMER_SUCCESS", any>;
export type GetMemberTierCustomerActionFailure =
  remoteAction.MerchantRemoteResponse<"GET_MEMBER_TIER_CUSTOMER_FAILURE", any>;
export type GetMemberTierCustomerActionRequest =
  remoteAction.MerchantRemoteResponse<"GET_MEMBER_TIER_CUSTOMER_REQUEST", any>;

export interface GetMemberTierCustomerAction
  extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_MEMBER_TIER_CUSTOMER_REQUEST";
    success: "GET_MEMBER_TIER_CUSTOMER_SUCCESS";
    failure: "GET_MEMBER_TIER_CUSTOMER_FAILURE";
  };
}

export function getMemberTierCustomerAction(): GetMemberTierCustomerAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_MEMBER_TIER_CUSTOMER_FAILURE",
      request: "GET_MEMBER_TIER_CUSTOMER_REQUEST",
      success: "GET_MEMBER_TIER_CUSTOMER_SUCCESS",
    },
    https: true,
    url: `/membertiers/customer/record`,
  };
}
